import * as React from "react";

import type { DesignaliProps } from "../../types";

export const WhatsApp = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          fill="#25d366"
          d="M19.09,4.87c-1.88-1.88-4.38-2.92-7.04-2.92C6.55,1.95,2.09,6.42,2.08,11.91c0,1.76.46,3.47,1.33,4.98l-1.41,5.16,5.28-1.38c1.45.79,3.09,1.21,4.76,1.21h0c5.49,0,9.96-4.47,9.96-9.96,0-2.66-1.03-5.16-2.91-7.04h0ZM12.04,20.19h0c-1.48,0-2.94-.4-4.21-1.15l-.3-.18-3.13.82.84-3.05-.2-.31c-.83-1.32-1.27-2.84-1.27-4.4,0-4.56,3.71-8.28,8.28-8.28,2.21,0,4.29.86,5.85,2.43,1.56,1.56,2.42,3.64,2.42,5.86,0,4.56-3.71,8.28-8.28,8.28h0ZM16.58,13.99c-.25-.12-1.47-.73-1.7-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.79.98-.15.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.15.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.56-1.35-.77-1.85-.2-.49-.41-.42-.56-.43-.15,0-.31,0-.48,0s-.44.06-.66.31c-.23.25-.87.85-.87,2.08s.89,2.41,1.02,2.57c.12.17,1.75,2.68,4.25,3.76.59.26,1.06.41,1.42.52.6.19,1.14.16,1.57.1.48-.07,1.47-.6,1.68-1.18.21-.58.21-1.08.15-1.18s-.23-.17-.48-.29h0Z"
        />
      </svg>
    );
  },
);

export default WhatsApp;
